import React, { useContext } from 'react'
import styled from '@emotion/styled'
import * as constants from 'view/styles/constants'
import { TearoutButton } from './TearoutButton'
import { EnvironmentContext } from '../environment'

const HeroPanelWrapper = styled.div<{ isTearout: boolean }>`
  display: flex;
  position: relative;
  flex: 0 0 ${props => (props.isTearout ? '130px' : '127px')};
  background-color: ${constants.CORE_PRIMARY_7};
  padding: 17px 32px 0 20px;
  color: white;
  font-family: NEXWeb;
  font-size: 24px;
  border-top-style: solid;
  border-top-color: ${constants.CORE_PRIMARY_1};
  border-top-width: ${props => (props.isTearout ? '3px' : '0')};
  border-radius: ${props => (props.isTearout ? '0' : '5px 5px 0 0')};
  overflow: hidden;
`

const TearoutButtonStyled = styled(TearoutButton)`
  position: absolute;
  top: 0;
  right: 0;
  margin: 9px;
`

export interface HeroPanelProps {
  onTearout?: () => void
  children?: React.ReactNode
}

export const HeroPanel: React.FunctionComponent<HeroPanelProps> = props => {
  const environment = useContext(EnvironmentContext)

  return (
    <HeroPanelWrapper aria-label="Information Panel" role="banner" isTearout={environment.isTearout}>
      {environment.isOpenFin && !environment.isTearout && props.onTearout && <TearoutButtonStyled onTearout={props.onTearout} />}
      {props.children}
    </HeroPanelWrapper>
  )
}
